import { isSedeMode } from '../../utils/partnerAccess/partnerStorage';
import { returnToOwnCompany } from '../../utils/partnerAccess/sedeSession';

export const PARTNER_OVERVIEW_ROUTE = '/general';
// The partner's own account opens where the normal session does.
const OWN_ACCOUNT_ROUTE = '/chat';

// Leaving a sede reloads the page into the chat; this mark tells the next
// load that the partner asked for the overview.
export const PENDING_OVERVIEW_KEY = 'partnerAccess.pendingOverview';

// The partner asked for their own account: the chat keeps them there, instead
// of sending them to the overview, until they ask for the overview again.
// Under the prefix that login and logout clear (`clearPartnerAccessState`);
// it holds the user id so a mark never speaks for someone else.
export const OWN_ACCOUNT_KEY = 'partnerAccess.ownAccount';

const writeMark = (value) => {
  try {
    if (value) window.sessionStorage.setItem(PENDING_OVERVIEW_KEY, '1');
    else window.sessionStorage.removeItem(PENDING_OVERVIEW_KEY);
  } catch (error) {
    // Without tab storage the partner lands in the chat and opens the
    // overview from the menu again.
  }
};

/** True once when the previous page asked for the overview; clears the mark. */
export const consumePendingOverview = () => {
  try {
    const pending = window.sessionStorage.getItem(PENDING_OVERVIEW_KEY) === '1';
    if (pending) window.sessionStorage.removeItem(PENDING_OVERVIEW_KEY);
    return pending;
  } catch (error) {
    return false;
  }
};

const writeOwnAccount = (userId) => {
  try {
    if (userId) window.sessionStorage.setItem(OWN_ACCOUNT_KEY, userId);
    else window.sessionStorage.removeItem(OWN_ACCOUNT_KEY);
  } catch (error) {
    // Without tab storage the chat sends the partner to the overview again.
  }
};

/** Whether `userId` asked for their own account in this tab, and not for the overview since. */
export const choseOwnAccount = (userId) => {
  try {
    // The storage only holds strings, whatever the id was when it was written.
    return Boolean(userId) && window.sessionStorage.getItem(OWN_ACCOUNT_KEY) === String(userId);
  } catch (error) {
    return false;
  }
};

/**
 * Takes the partner from the overview to their own account, and marks the tab
 * so the chat does not send them back. The overview never opens in a sede tab
 * (the router keeps it out), so there is no sede to leave here.
 */
export const goToOwnAccount = (history, userId) => {
  // A request for the overview left behind would undo this on the next load.
  writeMark(false);
  writeOwnAccount(userId);
  history.push(OWN_ACCOUNT_ROUTE);
};

/**
 * Takes the partner to the overview of all the sedes. From inside a sede the
 * tab first goes back to the partner's own account, which reloads the page.
 */
export const goToPartnerOverview = (history) => {
  // Asking for the overview ends a stay in the own account.
  writeOwnAccount(null);
  if (isSedeMode()) {
    writeMark(true);
    try {
      returnToOwnCompany();
    } catch (error) {
      // The tab did not reload: a mark left behind would send a later,
      // unrelated load to the overview.
      writeMark(false);
      throw error;
    }
    return;
  }
  writeMark(false);
  history.push(PARTNER_OVERVIEW_ROUTE);
};
